import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Button, Spinner, Alert, Form,
    InputGroup
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function DocumentsNumerotation() {
    const navigate = useNavigate();
    const [config, setConfig] = useState({
        facture_prefix: 'FAC',
        facture_annee: true,
        facture_mois: true,
        facture_chiffres: 4,
        devis_prefix: 'DEV',
        devis_annee: true,
        devis_mois: true,
        devis_chiffres: 4,
        commande_prefix: 'CMD',
        commande_annee: true,
        commande_mois: true,
        commande_chiffres: 4,
        bl_prefix: 'BL',
        bl_annee: true,
        bl_mois: true,
        bl_chiffres: 4
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        fetchConfig();
    }, []);

    const fetchConfig = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/parametres.php?action=numerotation',
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setConfig(result.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setConfig({
            ...config,
            [name]: type === 'checkbox' ? checked : value
        });
    };

   const handleSubmit = async (e) => {
    e.preventDefault();
    
    setSaving(true);
    setError(null);
    setSuccess(false);
    
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            'https://sawd.julesferry-ga.com/api/parametres.php',
            {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'update_numerotation',  // Assurez-vous que cette action existe
                    ...config
                })
            }
        );
        
        // Vérifier le statut de la réponse
        if (!response.ok) {
            const errorText = await response.text();
            console.error("Erreur API:", errorText);
            throw new Error(`Erreur ${response.status}: ${response.statusText}`);
        }
        
        const result = await response.json();
        
        if (result.success) {
            setSuccess(true);
            setTimeout(() => setSuccess(false), 3000);
        } else {
            setError(result.message || "Erreur lors de la sauvegarde");
        }
    } catch (err) {
        console.error("Erreur complète:", err);
        setError(err.message);
    } finally {
        setSaving(false);
    }
};

    const getExample = (prefix, annee, mois, chiffres, count = 1) => {
        let example = prefix;
        if (annee) example += new Date().getFullYear();
        if (mois) example += ('0' + (new Date().getMonth() + 1)).slice(-2);
        example += count.toString().padStart(chiffres, '0');
        return example;
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* En-tête */}
                    <Row className="mb-4 fade-in">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-3">
                                    <div 
                                        className="page-icon-wrapper d-flex align-items-center justify-content-center" 
                                        style={{ 
                                            width: '70px', 
                                            height: '70px', 
                                            borderRadius: '20px',
                                            background: 'linear-gradient(135deg, rgba(67, 97, 238, 0.15), rgba(58, 86, 212, 0.15))',
                                            boxShadow: '0 10px 20px rgba(67, 97, 238, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}
                                    >
                                        <i className="ri-file-list-3-line text-primary" style={{ fontSize: '36px', lineHeight: 1 }}></i>
                                    </div>
                                    <div>
                                        <h1 className="page-title mb-1">Numérotation des documents</h1>
                                        <p className="text-muted mb-0">Configuration des formats de numérotation</p>
                                    </div>
                                </div>
                                <Button variant="outline-secondary" onClick={() => navigate('/parametres')}>
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {/* Messages */}
                    {success && (
                        <Alert variant="success" className="mb-4">
                            <i className="ri-checkbox-circle-line me-2"></i>
                            Configuration mise à jour avec succès
                        </Alert>
                    )}
                    
                    {error && (
                        <Alert variant="danger" className="mb-4">
                            <i className="ri-error-warning-line me-2"></i>
                            {error}
                        </Alert>
                    )}

                    {/* Formulaire */}
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <h5 className="mb-3">Factures</h5>
                                <Row className="g-3 mb-4">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Préfixe</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="facture_prefix"
                                                value={config.facture_prefix}
                                                onChange={handleChange}
                                                maxLength="5"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Année</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="facture-annee"
                                                name="facture_annee"
                                                label="Inclure l'année"
                                                checked={config.facture_annee}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Mois</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="facture-mois"
                                                name="facture_mois"
                                                label="Inclure le mois"
                                                checked={config.facture_mois}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Nombre de chiffres</Form.Label>
                                            <Form.Select
                                                name="facture_chiffres"
                                                value={config.facture_chiffres}
                                                onChange={handleChange}
                                            >
                                                <option value="3">3 (001)</option>
                                                <option value="4">4 (0001)</option>
                                                <option value="5">5 (00001)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <div className="bg-light p-3 rounded-3">
                                            <small className="text-muted">Exemple: </small>
                                            <code className="ms-2">
                                                {getExample(
                                                    config.facture_prefix,
                                                    config.facture_annee,
                                                    config.facture_mois,
                                                    config.facture_chiffres
                                                )}
                                            </code>
                                        </div>
                                    </Col>
                                </Row>

                                <hr className="my-4" />

                                <h5 className="mb-3">Devis</h5>
                                <Row className="g-3 mb-4">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Préfixe</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="devis_prefix"
                                                value={config.devis_prefix}
                                                onChange={handleChange}
                                                maxLength="5"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Année</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="devis-annee"
                                                name="devis_annee"
                                                label="Inclure l'année"
                                                checked={config.devis_annee}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Mois</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="devis-mois"
                                                name="devis_mois"
                                                label="Inclure le mois"
                                                checked={config.devis_mois}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Nombre de chiffres</Form.Label>
                                            <Form.Select
                                                name="devis_chiffres"
                                                value={config.devis_chiffres}
                                                onChange={handleChange}
                                            >
                                                <option value="3">3 (001)</option>
                                                <option value="4">4 (0001)</option>
                                                <option value="5">5 (00001)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <div className="bg-light p-3 rounded-3">
                                            <small className="text-muted">Exemple: </small>
                                            <code className="ms-2">
                                                {getExample(
                                                    config.devis_prefix,
                                                    config.devis_annee,
                                                    config.devis_mois,
                                                    config.devis_chiffres
                                                )}
                                            </code>
                                        </div>
                                    </Col>
                                </Row>

                                <hr className="my-4" />

                                <h5 className="mb-3">Commandes fournisseurs</h5>
                                <Row className="g-3 mb-4">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Préfixe</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="commande_prefix"
                                                value={config.commande_prefix}
                                                onChange={handleChange}
                                                maxLength="5"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Année</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="commande-annee"
                                                name="commande_annee"
                                                label="Inclure l'année"
                                                checked={config.commande_annee}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Mois</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="commande-mois"
                                                name="commande_mois"
                                                label="Inclure le mois"
                                                checked={config.commande_mois}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Nombre de chiffres</Form.Label>
                                            <Form.Select
                                                name="commande_chiffres"
                                                value={config.commande_chiffres}
                                                onChange={handleChange}
                                            >
                                                <option value="3">3 (001)</option>
                                                <option value="4">4 (0001)</option>
                                                <option value="5">5 (00001)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <div className="bg-light p-3 rounded-3">
                                            <small className="text-muted">Exemple: </small>
                                            <code className="ms-2">
                                                {getExample(
                                                    config.commande_prefix,
                                                    config.commande_annee,
                                                    config.commande_mois,
                                                    config.commande_chiffres
                                                )}
                                            </code>
                                        </div>
                                    </Col>
                                </Row>

                                <hr className="my-4" />

                                <h5 className="mb-3">Bons de livraison</h5>
                                <Row className="g-3 mb-4">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Préfixe</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="bl_prefix"
                                                value={config.bl_prefix}
                                                onChange={handleChange}
                                                maxLength="5"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Année</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="bl-annee"
                                                name="bl_annee"
                                                label="Inclure l'année"
                                                checked={config.bl_annee}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Mois</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="bl-mois"
                                                name="bl_mois"
                                                label="Inclure le mois"
                                                checked={config.bl_mois}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Nombre de chiffres</Form.Label>
                                            <Form.Select
                                                name="bl_chiffres"
                                                value={config.bl_chiffres}
                                                onChange={handleChange}
                                            >
                                                <option value="3">3 (001)</option>
                                                <option value="4">4 (0001)</option>
                                                <option value="5">5 (00001)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <div className="bg-light p-3 rounded-3">
                                            <small className="text-muted">Exemple: </small>
                                            <code className="ms-2">
                                                {getExample(
                                                    config.bl_prefix,
                                                    config.bl_annee,
                                                    config.bl_mois,
                                                    config.bl_chiffres
                                                )}
                                            </code>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="border-top pt-4 mt-4">
                                    <Button 
                                        type="submit" 
                                        variant="primary" 
                                        className="px-5"
                                        disabled={saving}
                                    >
                                        {saving ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Sauvegarde...
                                            </>
                                        ) : (
                                            'Enregistrer'
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>

                <style>{`
                    .fade-in { animation: fadeIn 0.5s ease; }
                    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                `}</style>

                <Footer />
            </div>
        </>
    );
}